import React, { useEffect, useState } from "react";
import axios from "axios";
import { backend_url } from "../App";
import { menuItems } from "../Constants/menuItems";
import "./CSS/varietyAccessories.css";
import { isAdmin } from "../utils/roleUtils";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import crossIcon from "../Components/Assets/delete.png";
import editIcon from "../Components/Assets/edit.png";

const BrowseByVideos = () => {
  const [videos, setVideos] = useState([]);
  const [products, setProducts] = useState([]);
  const [selectedProductIds, setSelectedProductIds] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [editingVideoId, setEditingVideoId] = useState(null);
  const [showConfirm, setShowConfirm] = useState(false);
  const [selectedVideoId, setSelectedVideoId] = useState(null);

  const handleDelete = (_id) => {
    setSelectedVideoId(_id);
    setShowConfirm(true);
  };

  const [formData, setFormData] = useState({
    category: "",
    subCategory: "",
    video: null,
  });

  useEffect(() => {
    fetchVideos();
    fetchProducts();
  }, []);

  const fetchVideos = async () => {
    try {
      const response = await axios.get(`${backend_url}/api/browseVideos`);
      setVideos(response.data);
    } catch (error) {
      console.error("Error fetching videos:", error);
    }
  };

  const fetchProducts = async () => {
    try {
      const response = await axios.get(`${backend_url}/allproducts`);
      setProducts(response.data);
    } catch (error) {
      console.error("Error fetching products:", error);
    }
  };

  const handleChange = (e) => {
    const { name, value, files } = e.target;
    if (name === "video") {
      setFormData({ ...formData, video: files[0] });
    } else {
      setFormData({ ...formData, [name]: value });
      if (name === "category" || name === "subCategory") {
        setSelectedProductIds([]);
      }
    }
  };

  const handleProductSelection = (productId) => {
    setSelectedProductIds((prev) => {
      if (prev.includes(productId)) {
        return prev.filter((id) => id !== productId);
      } else {
        if (prev.length >= 6) {
          toast.error("You can select up to 5 products only.");
          return prev;
        }
        return [...prev, productId];
      }
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (selectedProductIds.length === 0) {
      toast.error("Please select at least one product.");
      return;
    }

    if (!formData.video && !editingVideoId) {
      toast.error("Please upload a video file.");
      return;
    }

    if (formData.video && formData.video.size > 20 * 1024 * 1024) {
      toast.error("File size exceeds 20MB limit.");
      return;
    }

    const data = new FormData();
    data.append("category", formData.category);
    data.append("subCategory", formData.subCategory);
    if (formData.video) {
      data.append("video", formData.video);
    }
    selectedProductIds.forEach((id) => data.append("productIds", id));

    try {
      if (editingVideoId) {
        await axios.put(
          `${backend_url}/api/browseVideos/${editingVideoId}`,
          data
        );
        toast.success("Video updated successfully!");
      } else {
        await axios.post(`${backend_url}/api/browseVideos`, data);
        toast.success("Video added successfully!");
      }
      fetchVideos();
      closeModal();
    } catch (error) {
      toast.error("Error uploading video:", error);
    }
  };

  const handleEdit = (video) => {
    setEditingVideoId(video._id);
    setFormData({
      category: video.category,
      subCategory: video.subCategory,
      video: null,
    });

    setSelectedProductIds(video.productIds.map((product) => product._id));
    setShowModal(true);
  };

  const closeModal = () => {
    setShowModal(false);
    setFormData({
      category: "",
      subCategory: "",
      video: null,
    });
    setSelectedProductIds([]);
    setEditingVideoId(null);
  };

  const filteredProducts = products.filter(
    (product) =>
      product.category === formData.category &&
      product.subcategory === formData.subCategory
  );

  // Handle delete
  const confirmDelete = async (id) => {
    try {
      await axios.delete(`${backend_url}/api/browseVideos/${id}`);
      setShowConfirm(false);
      toast.success("Video Deleted Successfully");
      fetchVideos(); //Refresh after deletion
    } catch (error) {
      console.error("Error deleting video:", error);
    }
  };

  const formatText = (text) =>
    text.replace(/-/g, " ").replace(/\b\w/g, (char) => char.toUpperCase());

  return (
    <div className="variety-admin">
      <div className="headerSections">
        <div className="head-title">Browse by Videos</div>
        {/* {videos.length < 4 && ( */}
        <button className="add-btn" onClick={() => setShowModal(true)}>
          + Add Video
        </button>
        {/* )} */}
      </div>

      {showModal && (
        <div className="modal-overlay">
          <div className="modal" style={{ width: "90%", maxWidth: "900px" }}>
            <div className="modal-content-videos">
              {/* Left Section */}
              <div className="left-section">
                <form onSubmit={handleSubmit}>
                  <label>Category:</label>
                  <select
                    name="category"
                    value={formData.category}
                    onChange={handleChange}
                    required
                  >
                    <option value="">Select Category</option>
                    {menuItems.map((menu) => (
                      <option key={menu.value} value={menu.value}>
                        {menu.label}
                      </option>
                    ))}
                  </select>

                  <label>Sub Category:</label>
                  <select
                    name="subCategory"
                    value={formData.subCategory}
                    onChange={handleChange}
                    required
                    disabled={!formData.category}
                  >
                    <option value="">Select Sub Category</option>
                    {menuItems
                      .find((menu) => menu.value === formData.category)
                      ?.dropdown.flatMap(
                        (item) =>
                          item.subcategories
                            ? item.subcategories.map((sub) => (
                                <option key={sub.value} value={sub.value}>
                                  {sub.label}
                                </option>
                              ))
                            : item.value !== null
                            ? [
                                <option key={item.value} value={item.value}>
                                  {item.label}
                                </option>,
                              ]
                            : [] // If value is null and no subcategories, ignore
                      )}
                  </select>

                  <label>Video File:</label>
                  <input
                    type="file"
                    name="video"
                    accept="video/*"
                    onChange={handleChange}
                  />
                  {editingVideoId && !formData.video && (
                    <p
                      style={{
                        marginTop: "5px",
                        fontSize: "14px",
                        color: "#555",
                      }}
                    >
                      Existing Video:{" "}
                      <a
                        href={
                          videos.find((v) => v._id === editingVideoId)?.videoUrl
                        }
                        target="_blank"
                        rel="noreferrer"
                      >
                        View Video
                      </a>
                    </p>
                  )}

                  <div className="form-buttons">
                    <button type="submit" className="submit-btn">
                      {editingVideoId ? "Update" : "Upload"}
                    </button>
                    <button
                      type="button"
                      className="cancel-btn"
                      onClick={closeModal}
                    >
                      Cancel
                    </button>
                  </div>
                </form>
              </div>

              {/* Right Section */}
              <div className="right-section">
                <h3>Available Products</h3>
                <div className="products-container">
                  <table className="products-table">
                    <thead>
                      <tr>
                        <th>Image</th>
                        <th>Name</th>
                        <th>Select</th>
                      </tr>
                    </thead>
                    <tbody>
                      {[...filteredProducts]
                        .sort((a, b) => {
                          const aSelected = selectedProductIds.includes(a._id)
                            ? -1
                            : 1;
                          const bSelected = selectedProductIds.includes(b._id)
                            ? -1
                            : 1;
                          return aSelected - bSelected;
                        })
                        .map((product) => (
                          <tr key={product._id}>
                            <td>
                              <img
                                src={product.images?.[0] || "default-image.png"}
                                alt={product.name}
                                className="product-image"
                              />
                            </td>
                            <td>{product.name}</td>
                            <td style={{ textAlign: "center" }}>
                              <input
                                type="checkbox"
                                checked={selectedProductIds.includes(
                                  product._id
                                )}
                                onChange={() =>
                                  handleProductSelection(product._id)
                                }
                              />
                            </td>
                          </tr>
                        ))}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Display Videos */}
      <div className="video-grid">
        {videos.map((video) => (
          <div className="video-card" key={video._id}>
            <video className="video-player" autoPlay loop muted>
              <source src={`${video.videoUrl}`} />
            </video>
            <div className="video-details">
              {/* Action Buttons in Top Right Corner */}
              <div className="header-section-video">
                <div className="video-actions">
                  <button
                    className="edit-btn"
                    onClick={() => handleEdit(video)}
                  >
                    <img
                      src={editIcon}
                      alt="editIcon"
                      style={{ width: "20px" }}
                    />
                  </button>
                  {isAdmin() && (
                    <button
                      className="delete-btn"
                      onClick={() => handleDelete(video._id)}
                    >
                      <img
                        src={crossIcon}
                        alt="deleteIcon"
                        style={{ width: "20px" }}
                      />
                    </button>
                  )}
                </div>
                <div>
                  <h3>{formatText(video.category)}</h3>
                  <p>{formatText(video.subCategory)}</p>
                </div>
              </div>
              <div className="product-list-scroll">
                <ol>
                  {video.productIds.map((product) => (
                    <li key={product._id}>{product.name}</li>
                  ))}
                </ol>
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* Confirmation Popup */}
      {showConfirm && (
        <div className="confirm-popup">
          <div className="confirm-content">
            <p>Are you sure you want to delete this video?</p>
            <div className="popup-actions">
              <button
                onClick={() => confirmDelete(selectedVideoId)}
                className="confirm-btn"
              >
                Confirm
              </button>
              <button
                onClick={() => setShowConfirm(false)}
                className="cancel-btn"
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}
      <ToastContainer />
    </div>
  );
};

export default BrowseByVideos;
